const informationService = {
  emailRex:
    '^[\\.a-zA-Z0-9_-]+(\\+[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\\.[a-zA-Z]{2,4})$',
  formatPhone: phone => {
    // phone --string
    const num = phone.replace(/[^\d]/g, '');
    const c = num
      .match(/(\d{3})?(\d{3})?(\d{4})?(\d*)/i)
      .slice(1)
      .filter(v => v)
      .slice(0, 3);
    return c[0]
      ? '(' + c[0] + (c[1] ? ')' + ' ' + c[1] + (c[2] ? '-' + c[2] : '') : '')
      : '';
  },
  isMobile: () => {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      return true
    }
    return false
  }
};
export default informationService;